import graphqlClient from '~/graphql/graphqlClient';
import {
  QueryGetShopInventoryArgs,
  ShopInventoryResult,
} from 'dt-common/generated/graphql-types';

const query = `
query GetShopInventory($playerId: String!) {
  getShopInventory(playerId: $playerId) {
    shopInventory
    last_restock
  }
}
`;

export default async function queryGetShopInventory(
  args: QueryGetShopInventoryArgs
): Promise<ShopInventoryResult> {
  return await graphqlClient.request<ShopInventoryResult>(
    'getShopInventory',
    query,
    args
  );
}
